<template>
  <div class="box-text-long">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BoxTextLong"
};
</script>

<style lang="scss" scoped>
.box-text-long {
  padding-left: 0.6532rem;
  padding-right: 0.6532rem;
}

@media (min-width: 768px) {
  .box-text-long {
    padding-left: 0.9199rem;
    padding-right: 0.9199rem;
  }
}
</style>
